<template>
    <div class="sub_Navi">
        <ul>
            <li><a class="back" @click="changeAlarmState">뒤로</a></li>
            <li>
                <h1>{{ $t('alarm.price.alarmSetting') }}</h1>

            </li>
            <li class="linkBox"></li>
        </ul>
    </div>
    <div class="subPage_container price">
        <div class="form_wrap price">
            <h3 class="title">{{ $t('alarm.price.exchange') }}</h3>
            <input type="text" id="exchange" name="exchange" class="form_select w100 modal_open" @click="
                toggleModal('exchange');
            " :value="alarmRegInfo.exchange.toUpperCase()" :placeholder="$t('alarm.price.selectEx')" readonly
                data-modal="1" />
            <h3 class="title">{{ $t('alarm.price.coin') }}</h3>
            <input type="text" id="coin" name="coin" class="form_select w100 modal_open" :value="alarmRegInfo.coin"
                :placeholder="$t('alarm.price.selectCoin')" readonly data-modal="3" @click="isExchange" />
            <h3 class="title">{{ $t('alarm.price.currentPrice') }}</h3>
            <input type="text" id="price" name="price" class="form_input_noTxt w100 num cur_price"
                :value="convertPrice(alarmRegInfo.currentPrice, alarmRegInfo.quote)" readonly />
            <h3 class="title">{{ $t('alarm.price.setPrice') }}</h3>
            <input type="text" id="set_price" name="set_price" class="form_input w100" v-model="alarmRegInfo.price"
                @input="enterPrice($event)" :placeholder="$t('alarm.price.enterPrice')" />
            <h3 class="title">{{ $t('alarm.price.setPercent') }}</h3>
            <input type="text" id="percent" name="percent" class="form_select w100 modal_open" @click="
                toggleModal('percent');
            " :value="convertPercent(alarmRegInfo.percent)" :placeholder="$t('alarm.price.selectPercent')" readonly
                data-modal="4" />
            <p class="txt_info">{{ $t('alarm.price.percentText') }}</p>
            <h3 class="title">{{ $t('alarm.price.condition') }}</h3>
            <input type="text" id="alarm_condition" name="alarm_condition" class="form_select w100 modal_open" @click="
                toggleModal('alarm_condition');
            " :value="translateType(alarmRegInfo.type)" :placeholder="$t('alarm.price.selectCoindition')" readonly
                data-modal="5" />
            <h3 class="title">{{ $t('alarm.price.period') }}</h3>
            <input type="text" id="alarm_period" name="alarm_period" class="form_select w100 modal_open" @click="
                toggleModal('alarm_period');
            " :value="translateCycle(alarmRegInfo.cycle)" :placeholder="$t('alarm.price.selectPeriod')" readonly
                data-modal="6" />
            <h3 class="title">{{ $t('alarm.price.sound') }}</h3>
            <input type="text" id="alarm_sound" name="alarm_sound" class="form_select w100 modal_open" @click="
                toggleModal('alarm_sound');
            " :value="translateSound(alarmRegInfo.soundId)" :placeholder="$t('alarm.price.selectSound')" readonly
                data-modal="7" />
            <h3 class="title">{{ $t('alarm.price.memo') }}</h3>
            <textarea name="" cols="20" rows="5" class="form_textarea" v-model="memo" @change="setMemo"></textarea>
        </div>
        </div>
    <div class="modalBackColor" :class="{ modalPop: isModalVisible['bg'] }"></div>

    <div class="modal_wrap modal_no1" data-modal="1" :class="{ modalPop: isModalVisible['exchange'] }">
        <div class="modal_title">{{ $t('alarm.price.exchange') }} <div class="mdcolsebtn" @click="
            toggleModal('exchange')"></div>
        </div>
        <div class="modal_content">
            <div class="modal_exchange_list">
                <ul>
                    <li v-for="(exchange, i) in Object.keys(symbolList)" :key="i"
                        @click="liExchangeCHk(exchange, $event)"
                        :class="{ active: alarmRegInfo.exchange === exchange }">
                        <div class="lt_1" :class="{ active: alarmRegInfo.exchange === exchange }">
                            <div class="exc_img">
                                <img :src="getExchangeImage(exchange)" :alt="exchange" />
                            </div>
                            <h3 class="exc_name">{{ exchange }}</h3>
                        </div>
                        <div class="lt_2">
                            <input type="radio" :id="exchange" :checked="alarmRegInfo.exchange == exchange" name="exChk" :value="exchange" @change="exchangeChk(exchange)">
                            <label :for="exchange"></label>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="modal_wrap modal_no3" data-modal="3" :class="{ modalPop: isModalVisible['coin'] }">
        <div class="modal_title">{{ $t('alarm.price.coin') }} <div class="mdcolsebtn" @click="
            toggleModal('coin')"></div>
        </div>
        <div class="modal_content">
            <div class="search_wrp_all">
                <div class="search_wrp">
                    <input type="text" id="search" name="search" class="search_input"
                        :placeholder="$t('alarm.score.searchCoin')" v-model="searchQuery" />
                    <button class="search_clear" @click="searchQuery = ''"></button>
                </div>
            </div>
            <div class="modal_coin_list">
                <ul>
                    <li v-for="(coin, i) in filteredCoinList" :key="i" @click.stop="liCoinChk(coin, $event)"
                        :class="{ active: alarmRegInfo.coin === coin }">
                        <div class="lt_1" :class="{ active: alarmRegInfo.coin === coin }">
                            <div class="coin_img"><img :src="getImagePath(coin)"></div>
                            <h3 class="coin_name">{{ coin }}</h3>
                        </div>
                        <div class="lt_2">
                            <input type="radio" :value="coin" :id="coin" name="coinChk"
                                @change.capture.stop="coinChk(coin)" :checked="alarmRegInfo.coin == coin">
                            <label :for="coin"></label>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="modal_wrap modal_no4" data-modal="4" :class="{ modalPop: isModalVisible['percent'] }">
        <div class="modal_title">{{ $t('alarm.price.setPercent') }} <div class="mdcolsebtn" @click="
            toggleModal('percent')"></div>
        </div>
        <div class="modal_content">
            <div class="modal_percent_list">
                <ul>
                    <li v-for="(percent, i) in setPercent" :key="i" @click="liPercentChk(percent, $event)"
                        :class="{ active: alarmRegInfo.percent === percent }">
                        <div class="lt_1" :class="{ active: alarmRegInfo.percent === percent }">
                            <h3 class="vol_name" >{{ percent }}%</h3>
                        </div>
                        <div class="lt_2">
                            <input type="radio" :checked="percent == alarmRegInfo.percent"
                                :id="`percentChk_00${i + 1}`" name="percentChk" :value="percent"
                                @change="percentChk(percent)">
                            <label :for="`percentChk_00${i + 1}`"></label>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="modal_wrap modal_no5" data-modal="5" :class="{ modalPop: isModalVisible['alarm_condition'] }">
        <div class="modal_title">{{ $t('alarm.price.condition') }} <div class="mdcolsebtn" @click="
            toggleModal('alarm_condition')"></div>
        </div>
        <div class="modal_content">
            <div class="modal_alram_list">
                <ul>
                    <li v-for="(alarm, i) in alarmTypeList" :key="i" @click="liAlarmChk(alarm.type, $event)"
                        :class="{ active: alarmRegInfo.type === alarm.type }">
                        <div class="lt_1" :class="{ active: alarmRegInfo.type === alarm.type }">
                            <h3 class="alram_name">{{ alarm.name }}</h3>
                        </div>
                        <div class="lt_2">
                            <input type="radio" :id="`alramChk_00${i + 1}`" :value="alarm.type"
                                name="alramChk" @change="alarmChk($event)"
                                :checked="alarmRegInfo.type === alarm.type">
                            <label :for="`alramChk_00${i + 1}`"></label>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="modal_wrap modal_no6" data-modal="6" :class="{ modalPop: isModalVisible['alarm_period'] }">
        <div class="modal_title">{{ $t('alarm.price.period') }} <div class="mdcolsebtn" @click="
            toggleModal('alarm_period')"></div>
        </div>
        <div class="modal_content">
            <div class="modal_alram_list">
                <ul>
                    <li v-for="(alarm, i) in alarmPeriodList" :key="i" @click="liPeriodChk(alarm.period, $event)"
                        :class="{ active: alarmRegInfo.cycle === alarm.period }">
                        <div class="lt_1" :class="{ active: alarmRegInfo.cycle === alarm.period }">
                            <h3 class="alram_name">{{ alarm.name }}</h3>
                        </div>
                        <div class="lt_2">
                            <input type="radio" :id="`periodChk_00${i + 1}`" :value="alarm.period"
                                name="periodChk" @change="periodChk($event)"
                                :checked="alarmRegInfo.cycle === alarm.period">
                            <label :for="`periodChk_00${i + 1}`"></label>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="modal_wrap modal_no7" data-modal="7" :class="{ modalPop: isModalVisible['alarm_sound'] }">
        <div class="modal_title">{{ $t('alarm.price.sound') }} <div class="mdcolsebtn" @click="
            toggleModal('alarm_sound')"></div>
        </div>
        <div class="modal_content">
            <div class="modal_alram_list">
                <ul>
                    <li v-for="(name, i) in alarmList" :key="i" @click="liSoundChk(i + 1, $event)"
                        :class="{ active: alarmRegInfo.soundId === (i + 1) }">
                        <div class="lt_1" :class="{ active: alarmRegInfo.soundId === (i + 1) }">
                            <h3 class="alram_name">{{ name }}</h3>
                        </div>
                        <div class="lt_2">
                            <input type="radio" :id="`soundChk_00${i}`" name="soundChk" :value="i + 1"
                                @change="soundChk(i + 1)" :checked="alarmRegInfo.soundId === (i + 1)">
                            <label :for="`soundChk_00${i}`"></label>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- 마켓 모달창 : 끝 -->
    <div class="popupMessage">
        <span class="messageTxt"></span>
    </div>

    <ModalBtn @click="sendAlarmReg" />
</template>

<script>
import ModalBtn from "@/components/button/ModalBtn.vue";
// import SelectModal from "@/components/modal/SelectModal";
import { mapState, mapMutations } from "vuex";
// import { toggleModal } from "@/utils/modalControll.js";
import { postPriceAlarm, updatePriceAlarm } from "@/api/priceAlarmApi.js";
import { convertPrice, displaySetPrice } from "@/utils/priceFormat";
import {
    convertType,
    convertPercent,
    convertCycle,
} from "@/utils/textFormat";
import { popupControll } from "@/utils/modalText";
import { getImagePath } from '@/utils/getCoinImage'
import socketModule from "@/api/symbolSocketModule";
export default {
    name: "AlarmRegModal",
    components: {
        ModalBtn,
        // SelectModal,
    },
    emits: ["update-alarms"],
    created() {
        socketModule.connectWebSocket((symbolList) => { // exchange list 가져오기
            this.symbolList = symbolList.all_symbols;
            // console.log('this.symbolList', this.symbolList);
            if (this.alarmRegInfo.exchange != '') { // exchange있을때
                this.getCoinList(this.alarmRegInfo.exchange);
                if (this.alarmRegInfo.exchange == "Upbit") {
                    this.quote = "KRW"
                } else {
                    this.quote = "USDT"
                }
                if (this.alarmRegInfo.coin != "") {
                    let getPrice = {
                        "exchange": this.alarmRegInfo.exchange,
                        "quote": this.quote,
                        "coin": this.alarmRegInfo.coin
                    }
                    socketModule.connectPriceSocket(getPrice, (currentPrice) => { // 시세가져오기
                        // console.log('currentPrice 로', currentPrice)
                        this.currentPrice = currentPrice[0].price.toString().replace(/(\.\d*?[1-9])0+$|\.0*$/, '$1');
                        // console.log('currentPrice 소켓', this.currentPrice);
                        // this.percent = this.alarmRegInfo.percent
                        this.updateCurrentPrice({ currentPrice: Number(this.currentPrice) });
                        // console.log('모달 로드시에 가져온 현재가격 ', this.currentPrice);
                        socketModule.disconnectSocket();
                    })
                }
            }
        });
        this.memo = this.alarmRegInfo.memo;
        if (this.alarmRegInfo.edit == true) {
            // console.log('edit true');
            this.exchange = this.alarmRegInfo.exchange;
            this.coin = this.alarmRegInfo.coin
            // this.percent = this.alarmRegInfo.percent
            this.cycle = this.alarmRegInfo.cycle
            this.memo = this.alarmRegInfo.memo
            this.alarmType = this.alarmRegInfo.type
            this.soundId = this.alarmRegInfo.soundId
            this.setPrice = this.alarmRegInfo.price
            this.quote = this.alarmRegInfo.quote
            // console.log('edit 에서 가져올때', this.setPrice);
        }
    },
    computed: {
        ...mapState("alarmReg", ["clickAlarm", "alarmRegInfo"]),
        
        filteredCoinList() {
            let coinList = this.flattenCoinList();

            if (!this.searchQuery) {
                return coinList;
            }

            return coinList.filter(coin =>
                coin.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        }
    },
    mounted() {
        // window.addEventListener('popstate', this.onPopState);
        this.setPrice = this.setPriceChk(this.alarmRegInfo.percent, this.alarmRegInfo.currentPrice);
    },
    beforeUnmount() {
        // window.removeEventListener('popstate', this.onPopState);
        this.resetScroll();
    },
    data() {
        return {
            setPrice: "",
            memo: "",
            searchQuery: "", // 검색어 추적
            editPrice: 0,
            resetInfo: {
                exchange: "",
                quote: "USDT", // 마켓
                coin: "", //코인
                price: 0, //설정금액
                percent: null,
                type: "", // 알람조건
                cycle: "", // 주기
                soundId: null, // 알람소리
                memo: "", // 메모
                currentPrice: 0,
                edit: false,
            },
            isModalVisible: {
                exchange: false,
                coin: false,
                percent: false,
                alarm_condition: false,
                alarm_period: false,
                alarm_sound: false,
                bg: false,
            },
            percentCopy: null,
            exchange: '',
            symbolList: [],
            coinList: [],
            coin: "",
            currentPrice: 0,
            setPercent: [+3, +2, +1, -1, -2, -3],
            percent: null,
            alarmList: [`${this.$t("alarm.price.default")}`, `${this.$t("alarm.price.soundFormat", { number: 1 })}`, `${this.$t("alarm.price.soundFormat", { number: 2 })}`, `${this.$t("alarm.price.soundFormat", { number: 3 })}`, `${this.$t("alarm.price.soundFormat", { number: 4 })}`, `${this.$t("alarm.price.soundFormat", { number: 5 })}`, `${this.$t("alarm.price.soundFormat", { number: 6 })}`, `${this.$t("alarm.price.soundFormat", { number: 7 })}`, `${this.$t("alarm.price.soundFormat", { number: 8 })}`, `${this.$t("alarm.price.soundFormat", { number: 9 })}`],
            soundId: null,
            alarmTypeList: [{ "name": `${this.$t("alarm.price.UP")}`, "type": "UP" }, { "name": `${this.$t("alarm.price.DOWN")}`, "type": "DOWN" }, { "name": `${this.$t("alarm.price.LIMIT")}`, "type": "LIMIT" }],
            alarmType: "",
            alarmPeriodList: [{ "name": `${this.$t("alarm.price.ONCE")}`, "period": "ONCE" }, { "name": `${this.$t("alarm.price.MINUTE", { minute: 1 })}`, "period": "MINUTE_1" }, { "name": `${this.$t("alarm.price.MINUTE", { minute: 3 })}`, "period": "MINUTE_3" }, { "name": `${this.$t("alarm.price.MINUTE", { minute: 5 })}`, "period": "MINUTE_5" }, { "name": `${this.$t("alarm.price.MINUTE", { minute: 10 })}`, "period": "MINUTE_10" }, { "name": `${this.$t("alarm.price.MINUTE", { minute: 30 })}`, "period": "MINUTE_30" }, { "name": `${this.$t("alarm.price.HOUR", { hour: 1 })}`, "period": "HOUR_1" }, { "name": `${this.$t("alarm.price.HOUR", { hour: 6 })}`, "period": "HOUR_6" }, { "name": `${this.$t("alarm.price.HOUR", { hour: 12 })}`, "period": "HOUR_12" }, { "name": `${this.$t("alarm.price.DAY_1")}`, "period": "DAY_1" }],
            cycle: "",
            // percentWatch:"",
            quote: "USDT",
            eventProcessed: false,
            fallbackLoaded: false
        };
    },
    methods: {
        // toggleModal,
        convertPrice,
        displaySetPrice,
        convertType,
        convertPercent,
        convertCycle,
        getImagePath,
        popupControll,
        ...mapMutations("alarmReg", [
            "changeAlarm",
            "resetPercent",
            "priceTotal",
            "setMemoState",
            "resetAlarmModal",
            "updateCurrentPrice",
            "regAlarmAtModal"
        ]),
        // onPopState() {
        //     // if (this.clickAlarm) {
        //     this.changeAlarmState();
        //     history.pushState({ modal: true }, '');
        //     // }
        // },
        resetScroll() {
            const allElements = document.querySelectorAll('*');

            allElements.forEach(el => {
                if (el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth) {
                    el.scrollTo(0, 0);
                }
            });

            window.scrollTo(0, 0);
        },
        toggleModal(modalName) {
            for (let key in this.isModalVisible) {
                this.isModalVisible[key] = false;
            }
            this.isModalVisible[modalName] = true;
            this.isModalVisible['bg'] = true;
            // let modalBg = document.querySelector(".modalBackColor");
            let body = document.querySelector('body');
            let modalEl = document.querySelector(`#${modalName}`) || document.querySelector(`.${modalName}`);
            let modalNum = modalEl.getAttribute('data-modal');
            // let showEl = document.querySelector(`.modal_no${modalNum}`);
            // // console.log("modalEl",modalEl,'showel',showEl);
            body.style.overflow = 'hidden';
            body.style.position = 'fixed';
            body.style.width = '100%';
            // modalBg.style.display = 'block';
            // showEl.style.display = 'block';

            let closeBtn = document.querySelector(`.modal_no${modalNum} .mdcolsebtn`) || document.querySelector('.pop_close');
            closeBtn.addEventListener('click', () => {
                body.style.removeProperty('overflow');
                body.style.removeProperty('position');
                body.style.removeProperty('width');
                // modalBg.style.display = 'none';
                // showEl.style.display = 'none';
                this.isModalVisible[modalName] = false;
                this.isModalVisible['bg'] = false;
            });
        },
        isExchange() {
            if (this.exchange == "") {
                this.popupControll(this.$t("popup.selectExFirst"))
                return
            } else {
                this.isModalVisible['coin'] = true;
                this.isModalVisible['bg'] = true;
            }
        },
        changeAlarmState() {
            // this.changeAlarm({ state: false });
            this.resetAlarmModal({
                exchange: "",
                quote: "USDT", // 마켓
                coin: "", //코인
                price: "", //설정금액
                percent: null,
                type: "", // 알람조건
                cycle: "", // 주기
                soundId: null, // 알람소리
                memo: "", // 메모
                currentPrice: 0,
                edit: false,
            });
            // socketModule.disconnectSocket();
            this.$router.back();
        },
        // percent 변동시 설정금액도 바뀜 + 설정퍼센트 안정해져있으면 입력값으로

        setPriceChk(percent, currentPrice) {
            // 설정금액 value값
            // console.log("currentPrice", currentPrice);
            if (percent > 0) {
                this.setPrice = Number(currentPrice) * (1 + Number(percent) / 100);
                // console.log("퍼센트 계산값", this.setPrice, "설정금액 타입", typeof this.setPrice);
                // console.log('소수점 제거 타입'), this.displaySetPrice(this.setPrice, currentPrice);
                this.priceTotal({
                    setPrice: this.displaySetPrice(this.setPrice, currentPrice),
                });
            } else if (percent < 0) {
                let convertPlus = Math.abs(percent);
                this.setPrice = Number(currentPrice) * (1 - Number(convertPlus) / 100);
                this.priceTotal({
                    setPrice: this.displaySetPrice(this.setPrice, currentPrice),
                });
            }
            // percent가 null이고, 수정 모드가 아닐 때만 기존 로직 실행
            // if (percent == null ) {
            //     // console.log("this.setPrice", this.setPrice);
            //     // this.setPrice = Number(this.setPrice)
            //     // this.priceTotal({ setPrice: this.displaySetPrice(this.setPrice,currentPrice)}); // post 할 때 들어갈 alarmRegInfo.price
            //     // // console.log(typeof this.setPrice);
            //     // console.log(this.setPrice);
            //     this.priceTotal({ setPrice: this.setPrice });

            // }
            // else if (this.alarmRegInfo.edit) { // 수정 모드일 때 로직
            //     // 이 부분은 enterPrice 함수에 의해 사용자가 입력한 값으로 이미 설정되었을 수 있으므로,
            //     // 여기서 별도의 setPrice 업데이트를 수행하지 않아도 됩니다.
            //     this.setPrice = Number(this.alarmRegInfo.price);
            //     // console.log('Modifying mode, current setPrice:', this.setPrice);
            // }
            // this.priceTotal({ setPrice: this.setPrice });
            return this.alarmRegInfo.price; // 화면에 표시될 문자열 포매팅
        },
        enterPrice(event) {
            this.resetPercent({ percent: null });
            // // console.log(event.target.value);
            // this.setPrice = event.target.value;
            // // console.log(typeof event.target.value);
            const numberPattern = /^\d*\.?\d*$/; // 정규 표현식: 숫자와 소수점만 허용
            const inputValue = event.target.value;
            if (numberPattern.test(inputValue)) {
                // this.setPrice = this.setPrice; // 입력 값이 숫자 형식이라면 저장
                // 기타 필요한 동작 수행
                this.setPrice = inputValue;
                // console.log('숫자만 있음', typeof this.setPrice);

            } else {
                // 숫자 형식이 아닌 입력에 대한 처리
                this.setPrice = "";
                // console.log(this.setPrice);
                popupControll(this.$t("popup.onlyNumber"));

            }
            this.priceTotal({ setPrice: this.setPrice });
        },
        setMemo() {
            this.setMemoState({ memo: this.memo });
        },
        sendAlarmReg() {
            // // console.log('typeof(this.setPrice)',typeof(this.setPrice));
            // // console.log('memo',this.memo);
            // validation
            if (this.alarmRegInfo.exchange == "" || this.alarmRegInfo.coin == "") {
                popupControll(this.$t("popup.needToSelectAll"));
                return;
            } else if (this.setPrice == "") {
                popupControll(this.$t("popup.needToEnterPrice"));
                return;
            }
            // else if(typeof(this.setPrice) != "number"){
            //     popupControll('가격은 숫자만 입력가능합니다.')
            //     return;
            // }
            else if (this.alarmRegInfo.type == "") {
                popupControll(this.$t("popup.needToSelectCondition"));
                return;
            } else if (this.alarmRegInfo.cycle == "") {
                popupControll(this.$t("popup.needToSelectPeriod"));
                return;
            } else if (this.alarmRegInfo.soundId == "" || this.alarmRegInfo.soundId == null) {
                popupControll(this.$t("popup.needToSelectSound"));
                return;
            } else if (this.memo.length > 50) {
                popupControll(this.$t("popup.memoLimit"));
                return;
            }
            if (this.alarmRegInfo.edit == false) {
                postPriceAlarm(this.alarmRegInfo).then((res) => {
                    // console.log(res);
                    let data = res.data.data;
                    this.changeAlarmState();
                    this.$emit("update-alarms", data);
                });
            } else {
                if (this.alarmRegInfo.sameGroup == true) {
                    postPriceAlarm(this.alarmRegInfo).then((res) => {
                        // console.log(res);
                        let data = res.data.data;
                        this.changeAlarmState();
                        this.$emit("update-alarms", data);
                    });
                } else {
                    let alarmId = this.alarmRegInfo.id;
                    // // console.log('alarmId',alarmId);
                    updatePriceAlarm(this.alarmRegInfo, alarmId).then((res) => {
                        // console.log("res", res);
                        let data = res.data.data;
                        this.$emit("update-alarms", data);
                        // this.changeAlarmState();
                        this.$router.back();
                    });
                }
            }
            socketModule.disconnectSocket();
        },
        // handleModalVisible(newValue) {
        //     this.isModalVisible = newValue;
        //     // console.log("modalVisible", this.isModalVisible);
        // },
        updateRegAlarm() {
            this.regAlarmAtModal({
                exchange: this.exchange,
                coin: this.coin,
                percent: this.percent,
                soundId: this.soundId,
                type: this.alarmType,
                cycle: this.cycle,
                currentPrice: this.currentPrice,
                quote: this.quote
            })
        },
        isEmptyObj(obj) {
            if (obj.constructor === Object
                && Object.keys(obj).length === 0) {
                return true;
            }
            return false;
        },
        // 거래소 value값 확인
        liExchangeCHk(exchange, event) {
            if (event.target.type === 'radio') return;
            this.exchangeChk(exchange)
        },
        exchangeChk(exchange) {
            socketModule.disconnectSocket();
            var selectedEx = exchange;
            this.exchange = selectedEx;
            this.isModalVisible['exchange'] = false;
            this.isModalVisible['bg'] = false;
            // console.log(this.exchange);

            if (selectedEx == "Upbit") {
                this.quote = "KRW"
            } else {
                this.quote = "USDT"
            }

            // // console.log(convert);
            this.getCoinList(this.exchange);

            this.updateRegAlarm();

            // 가격 실시간 웹소켓 가져오기
            if (this.coin != "") {
                let getPrice = this.symbolList[this.exchange].find((el) => el.coin == this.coin)
                // console.log('getPrice', getPrice);
                if (getPrice != undefined) { // 거래소 코인목록에 있을떄
                    socketModule.connectPriceSocket(getPrice, (currentPrice) => {
                        // // console.log('currentPrice',currentPrice)
                        // console.log('빈객체', this.isEmptyObj(currentPrice[0]));

                        if (this.isEmptyObj(currentPrice[0]) == false) { // 상장폐지 안됐을때
                            this.currentPrice = currentPrice[0].price.toString().replace(/(\.\d*?[1-9])0+$|\.0*$/, '$1');
                            this.percent = this.alarmRegInfo.percent

                        } else {
                            this.percent = null
                            this.coin = "";
                            this.currentPrice = 0;
                            this.setPrice = ""
                            this.priceTotal({
                                setPrice: this.setPrice
                            });
                            // console.log('없는 코인');
                            this.popupControll(this.$t("popup.noDataForCoin"))
                        }
                        this.updateRegAlarm();
                        // console.log('this.currentPrice', this.currentPrice);
                        socketModule.disconnectSocket();
                    })
                } else {
                    this.popupControll(this.$t("popup.notExistCoin"))
                    this.coin = "";
                    this.currentPrice = 0;
                    this.setPrice = ""
                    this.updateRegAlarm();
                }
                // this.updateRegAlarm();
                this.setPrice = this.setPriceChk(this.alarmRegInfo.percent, this.alarmRegInfo.currentPrice)
                this.priceTotal({
                    setPrice: this.setPrice
                });
            }
        },
        liCoinChk(coin, event) {
            // // console.log('event.target.type',event.target.type);
            if (event.target.type === 'radio') return;
            this.coinChk(coin);
        },
        coinChk(coin) {
            socketModule.disconnectSocket();
            var selectedCoin = coin;
            this.coin = selectedCoin;
            this.isModalVisible['coin'] = false;
            this.isModalVisible['bg'] = false;
            this.updateRegAlarm();
            // this.isModalVisible = false;
            if (this.exchange == "Upbit") {
                this.quote = "KRW"
            } else {
                this.quote = "USDT"
            }
            let getPrice = this.symbolList[this.exchange].find((el) => el.coin == selectedCoin)
            // console.log('getPrice', getPrice);
            // 가격 실시간 웹소켓 가져오기
            socketModule.connectPriceSocket(getPrice, (currentPrice) => {
                // console.log('currentPrice', currentPrice)
                if (this.isEmptyObj(currentPrice[0]) == false) {
                    // // console.log('빈객체',this.isEmptyObj(currentPrice[0]));
                    this.currentPrice = currentPrice[0].price.toString().replace(/(\.\d*?[1-9])0+$|\.0*$/, '$1');
                    this.percent = this.alarmRegInfo.percent
                } else {
                    this.percent = null
                    this.coin = "";
                    this.currentPrice = 0;
                    this.setPrice = "";
                    this.priceTotal({
                        setPrice: this.setPrice
                    });
                    // // console.log('빈객체',this.isEmptyObj(currentPrice[0]));
                    // // console.log('없는 코인');
                    this.popupControll(this.$t("popup.noDataForCoin"))
                }
                socketModule.disconnectSocket();
                this.updateRegAlarm();
                this.setPrice = this.setPriceChk(this.alarmRegInfo.percent, this.alarmRegInfo.currentPrice)
                this.priceTotal({
                    setPrice: this.setPrice
                });
                // // console.log('this.currentPrice', this.currentPrice);
            })
        },
        async getCoinList(exchange) {
            this.coinList = [];
            await this.getExchangeCoin(exchange); // 선택된 거래소에 따른 코인 목록을 가져옴
        },

        async getExchangeCoin(exchange) {
            for (let i = 0; i < this.symbolList[`${exchange}`].length; i++) {
                this.coinList.push(
                    this.symbolList[`${exchange}`][i].coin
                );
            }
        },
        liPercentChk(percent, event) {
            if (event.target.type === 'radio') return;
            this.percentChk(percent)
        },
        percentChk(percent) {
            let percentVal = percent;
            // if(this.alarmRegInfo.percent == null){
            //     this.percent = this.alarmRegInfo.percent
            // }else{
            this.percent = percentVal;
            // }
            // console.log('모달퍼센트', this.percent);
            this.isModalVisible['percent'] = false;
            this.isModalVisible['bg'] = false;
            this.updateRegAlarm();
        },
        liSoundChk(sound, event) {
            if (event.target.type === 'radio') return;
            this.soundChk(sound)
        },
        soundChk(sound) {
            let soundVal = sound;
            this.soundId = (Number(soundVal));
            let adjustedSoundId = this.soundId - 1; // Adjust soundId to match the index in the alarmList

            // iOS (WKWebView)
            if (window.webkit?.messageHandlers?.soundSelected) {
                window.webkit.messageHandlers.soundSelected.postMessage(adjustedSoundId);
            }
            // Android (injected JS interface)
            if (window.Android?.soundSelected) {
                window.Android.soundSelected(adjustedSoundId);
            }
            // console.log(this.soundId);
            this.isModalVisible['alarm_sound'] = false;
            this.isModalVisible['bg'] = false;
            this.updateRegAlarm();
        },
        liAlarmChk(type, event) {
            if (event.target.type === 'radio') return;
            this.alarmChk(type);
        },
        alarmChk(type) {
            let alarmType = type;
            this.alarmType = alarmType;
            // console.log(this.alarmType);
            this.isModalVisible['alarm_condition'] = false;
            this.isModalVisible['bg'] = false;
            this.updateRegAlarm();
        },
        liPeriodChk(cycle, event) {
            if (event.target.type === 'radio') return;
            this.periodChk(cycle)
        },
        periodChk(cycle) {
            let period = cycle;
            this.cycle = period;
            // console.log(this.cycle);
            this.isModalVisible['alarm_period'] = false;
            this.isModalVisible['bg'] = false;
            this.updateRegAlarm();
        },
        getClass(percent) {
            if (percent > 0) {
                return 'txt_plus';
            } else if (percent < 0) {
                return 'txt_minus';
            }
        },
        translateType(type) {
            // if(type !='' || type != null){
            //     return this.$t(`alarm.price.${type}`)
            // }else{
            //     return null
            // }
            if (type == "") {
                return ""
            } else {
                return this.$t(`alarm.price.${type}`)
            }
        },
        translateCycle(cycle) {
            if (cycle == "ONCE" || cycle == "DAY_1") {
                return this.$t(`alarm.price.${cycle}`)
            } else if (cycle.split("_")[0] == "MINUTE") {
                return this.$t(`alarm.price.${cycle.split("_")[0]}`, { minute: cycle.split("_")[1] })
            } else if (cycle.split("_")[0] == "HOUR") {
                return this.$t(`alarm.price.${cycle.split("_")[0]}`, { hour: cycle.split("_")[1] })
            }
        },
        translateSound(sound) {
            if (sound == 1) {
                return this.$t("alarm.price.default")
            } else if (sound > 0) {
                return this.$t("alarm.price.soundFormat", { number: sound - 1 })
            } else {
                return null
            }
        },
        // 필터링 함수
        flattenCoinList() {
            return [].concat(...Object.values(this.coinList));
        },
        // 거래소 이미지 가져오는 함수
        getExchangeImage(exchange) {
            if (!this.fallbackLoaded) {
                try {
                    return require(`@/assets/images/exchange/ec_${exchange.toLowerCase()}.png`);
                } catch (e) {
                    this.fallbackLoaded = true;
                    return `/assets/images/exchange/ec_${exchange.toLowerCase()}.png`;
                }
            }
            else {
                return `/assets/images/exchange/ec_${this.exchange.toLowerCase()}.png`;
            }
        },
    },
    watch: {
        percent(newPercent) {
            this.setPriceChk(newPercent, this.alarmRegInfo.currentPrice)
        }
    },
};
</script>
<style scoped>
.modalPop {
    display: block !important;
}

.search_wrp_all {
    padding: 0 15px 10px;
    width: 100%;
    position: fixed;
    background-color: var(--Menu-Dark);
    z-index: 9999;
}

.search_wrp {
    position: relative;
    width: 100%;
    height: 44px;
    padding: 0 30px 0 50px;
    background: transparent url("@/assets/images/icon/common/search-white.png") left 10px center no-repeat;
    background-size: 30px;
    border-radius: 8px;
    border: 1px solid #7E8088;
}

.search_wrp .search_clear {
    position: absolute;
    top: 10px;
    right: 11px;
    width: 24px;
    height: 24px;
    background: url("@/assets/images/dark/icon_gray_x.png") center center no-repeat;
    background-size: 100%;
}

.search_wrp .search_input {
    background-color: transparent;
    color: var(--txt-default-color);
    height: 44px;
    line-height: 52px;
    margin: 0;
    width: 100%;
}

.search_wrp .search_input:focus {
    border: 0;
}

.modal_content {
    padding-top: 48px;
}

.modal_coin_list {
    padding-top: 48px;
}

.modal_wrap ul li.active {
    background: var(--Line, #393737);
}

.modal_exchange_list ul li .lt_1.active .exc_name {
    color: var(--primary-color);
}

</style>